import { axiosInstance, downloadBlobDataFile } from '~/services';

import type { TypeErrorResponseData } from '~/types/common.types';
import type { TypeGetOrdersOrderExcelParams } from '~/types/order.types';

/**
 * [출고주문관리 > 출고주문조회] 주문 엑셀 다운로드 API
 */
const useGetOrdersOrderExcel = () => {
  const endPoint = '/api-oms/orders/order-excel';

  const getOrdersOrderExcel = async (params: TypeGetOrdersOrderExcelParams) => {
    return axiosInstance
      .get(endPoint, {
        params,
        responseType: 'blob',
      })
      .then((data) => {
        downloadBlobDataFile(data);
      })
      .catch((error: TypeErrorResponseData['error']) => {
        throw error;
      });
  };

  return { getOrdersOrderExcel };
};

export default useGetOrdersOrderExcel;
